import InlineNotification from './InlineNotification';

export default InlineNotification;